import {colorBank} from '../../constants/ColorPicker';
import {TFontOptions} from './types';

export const defaultStyles = {
    fontFamily: 'Arial',
    fontSize: '14',
}

export const DEFAULT_COLORS_MAP = [...new Set(colorBank.map((color: any) => color.hex))];

export const FONT_FAMILY_OPTIONS: TFontOptions[] = [
    {label: defaultStyles.fontFamily, value: defaultStyles.fontFamily},
    {label: 'Courier New', value: 'Courier New'},
    {label: 'Georgia', value: 'Georgia'},
    {label: 'Times New Roman', value: 'Times New Roman'},
    {label: 'Trebuchet MS', value: 'Trebuchet MS'},
    {label: 'Verdana', value: 'Verdana'}
];

export const FONT_SIZE_OPTIONS: TFontOptions[] = [
    {label: '8', value: '8'},
    {label: '9', value: '9'},
    {label: '10', value: '10'},
    {label: '11', value: '11'},
    {label: '12', value: '12'},
    {label: defaultStyles.fontSize, value: defaultStyles.fontSize},
    {label: '16', value: '16'},
    {label: '18', value: '18'},
    {label: '20', value: '20'},
    {label: '22', value: '22'},
    {label: '24', value: '24'},
    {label: '26', value: '26'},
    {label: '28', value: '28'},
    {label: '36', value: '36'},
    {label: '48', value: '48'},
    {label: '72', value: '72'}
];

export const defaultFontSizeOption = FONT_SIZE_OPTIONS.find(item => item.value === defaultStyles.fontSize) || FONT_SIZE_OPTIONS[4];

export const defaultFontFamilyOption = FONT_FAMILY_OPTIONS.find(item => item.value === defaultStyles.fontFamily) || FONT_FAMILY_OPTIONS[0];

export const FONT_SIZE = 'font-size';

export const LINE_HEIGHT = 'line-height';

export const COMMAND_PRIORITY_LOW = 1;

export const emptyEditorJSON =
    '{"root":{"children":[{"children":[],"direction":null,"format":"","indent":0,"type":"paragraph","version":1}],"direction":null,"format":"","indent":0,"type":"root","version":1}}';



